import styled from 'styled-components';

import { Row } from 'ui/components/Grid';
import { Paragraph } from 'ui/components/Typography';

import { colors } from '@10d/tend-ui-tokens/samolet';

export const ParagraphWithoutMargin = styled(Paragraph)`
  && {
    margin: 0;
  }
`;

export const TextNoData = styled.div`
  font-size: 16px;
  text-align: center;
  color: #8f9cbc;
`;

export const RowWithHoverChildren = styled(Row)`
  &:hover {
    background-color: #eaedf5;
  }
`;

export const LinkHardColor = styled.a`
  color: ${colors.blue600};
`;

export const AlignByCenter = styled.div`
  display: flex;
  justify-content: center;
`;
